import { List, Map, Record } from 'immutable'
import { SUCCESS } from 'crom-api-constants'
import _ from 'lodash'

import {
    PORTFOLIO_GET_TOKEN_REQUEST,
    PORTFOLIO_GROUP_UPDATE,
    PORTFOLIO_GROUP_DELETE_UPDATE,
    CLOSE_PORTFOLIO_BY_ID,
} from '../../constants'

import { mergeDeepUpdates } from '../../../helpers'

const CountsRecord = Record({
    alreadyPaid: 0,
    foreign: 0,
    naturalPerson: 0,
    outOfBusiness: 0,
    toAnalyze: 0,
    toPay: 0,
    total: 0,
})

export const PortfolioRecord = Record({
    groupId: '',
    name: '',
    token: '',
    counts: new CountsRecord(),
    blocks: Map(),
    portfolioType: '',
})

const groupIdRegex = '\\d+' // group id must be only number (internally is string)

const tokenSuccessRegex = new RegExp(`^${PORTFOLIO_GET_TOKEN_REQUEST(groupIdRegex)}_${SUCCESS}$`)
const groupUpdateRegex = new RegExp(`^${PORTFOLIO_GROUP_UPDATE(groupIdRegex)}$`)
const groupDeleteUpdateRegex = new RegExp(`^${PORTFOLIO_GROUP_DELETE_UPDATE(groupIdRegex)}$`)
const closePortfolioRegex = new RegExp(`^${CLOSE_PORTFOLIO_BY_ID}$`)

export default function workspaceReducer(state = Map(), action = {}) {
    switch (true) {
        // PORTFOLIO_GET_groupId_TOKEN_REQUEST_SUCCESS
        case tokenSuccessRegex.test(action.type): {
            const data = _.get(action, 'payload.response.body.data', null)
            const groupId = _.toString(_.get(data, 'group.groupId', null))
            if (!data || !groupId) return state

            const portfolio = state
                .get(groupId, new PortfolioRecord())
                .set('groupId', groupId)
                .set('name', data.group.name)
                .set('token', data.token)
                .set('counts', new CountsRecord(data.group.counts))

            return state.set(groupId, portfolio)
        }
        // PORTFOLIO_GROUP_groupId_UPDATE
        case groupUpdateRegex.test(action.type): {
            const groupId = _.get(action, 'data.groupId', null)
            if (!groupId) return state

            const updates = _.get(action, 'data.updates', Map())
            return state.set(groupId, mergeDeepUpdates(state.get(groupId), updates))
        }
        // PORTFOLIO_GROUP_groupId_DELETE_UPDATE
        case groupDeleteUpdateRegex.test(action.type): {
            const groupId = _.get(action, 'data.groupId', null)
            if (!groupId) return state

            const deleteUpdates = _.get(action, 'data.deleteUpdates', List())
            const updatedGroup = deleteUpdates.reduce(
                (acc, path) => acc.deleteIn(path),
                state.get(groupId, new PortfolioRecord())
            )

            return state.set(groupId, updatedGroup)
        }
        // CLOSE_PORTFOLIO_BY_ID
        case closePortfolioRegex.test(action.type): {
            const groupId = _.get(action, 'data.id', null)
            if (!groupId) return state

            return state.delete(groupId)
        }
        default:
            return state
    }
}
